import { inject } from 'aurelia-framework';
import { FavoriteService } from 'resources/elements/favorite/service';

@inject(FavoriteService)
export class Favorites {
    constructor (favoriteService) {
        this.favoriteService = favoriteService;
    }
}